import { IonContent, Platform, NavController } from '@ionic/angular';
import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { LimitsService } from 'src/app/services/limits/limits.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
    selector: 'page-set-time-limits',
    templateUrl: './set-time-limits.component.html',
    styleUrls: ['./set-time-limits.component.scss']
})
export class SetTimeLimitsComponent implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;

    @ViewChild('timeCurrentLimit', {read: ElementRef}) timeCurrentLimit: ElementRef;
    @ViewChild('timeDelete', {read: ElementRef}) timeDelete: ElementRef;
    @ViewChild('timeRolloverPeriod', {read: ElementRef}) timeRolloverPeriod: ElementRef;
    @ViewChild('timeRolloverPeriodContent', {read: ElementRef}) timeRolloverPeriodContent: ElementRef;
    @ViewChild('timeRemoved', {read: ElementRef}) timeRemoved: ElementRef;
    @ViewChild('timeRemovedContent', {read: ElementRef}) timeRemovedContent: ElementRef;
    @ViewChild('timeAmountUsed', {read: ElementRef}) timeAmountUsed: ElementRef;
    @ViewChild('timeAmountUsedContent', {read: ElementRef}) timeAmountUsedContent: ElementRef;
    @ViewChild('timeNewLimit', {read: ElementRef}) timeNewLimit: ElementRef;
    @ViewChild('timeNewLimitError', {read: ElementRef}) timeNewLimitError: ElementRef;
    @ViewChild('timeNewLimitContent', {read: ElementRef}) timeNewLimitContent: ElementRef;
    @ViewChild('timeNewLimitEffective', {read: ElementRef}) timeNewLimitEffective: ElementRef;
    @ViewChild('timeNewLimitEffectiveContent', {read: ElementRef}) timeNewLimitEffectiveContent: ElementRef;
    @ViewChild('timePendingLimit', {read: ElementRef}) timePendingLimit: ElementRef;
    @ViewChild('timePendingLimitContent', {read: ElementRef}) timePendingLimitContent: ElementRef;

    public error = null;

    public timeLimitForm: FormGroup;

    public time_limit: AbstractControl;

    public timeLimits: any[] = [];

    public globalDailyLimit: any;

    public globalLimits: any[] = [];

    public totalLoginTime: string | number;

    public hours: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    public isMobile:boolean = false;

    @Input() previousPage: string = "";

    public labels: SiteContentInterface;


    constructor(
        private siteContentService: SiteContentService,
        private configService: ConfigService,
        private responsibleGamingProvider: ResponsibleGamingService,
        public successMessageProvider: SuccessMessageService,
        private platform:Platform,
        public navCtrl: NavController,
        public utils: UtilsService,
        public dateFormatPipe: DateFormatPipe,
        public limitsService: LimitsService
        ) {

        this.detectMobile();
        this.labels = new SiteContentModel();
        this.successMessageProvider.clearMessage();
        this.error = null;
    }

    ngAfterViewInit(){
      this.siteContentService.loadConfig('time_limit')
      .then((response: SiteContentInterface) => {
        this.labels = response
      })
    }
    ngOnInit() {
        this.timeLimitForm = new FormGroup(
            {
                time_limit: new FormControl('', [Validators.pattern('^[0-9]*')]),
            },  this.atLeastOneFieldValidator
        );

        this.time_limit = this.timeLimitForm.get('time_limit');

        this.getGlobalLimits();
        this.getTotalLoginTime();
    }

    detectMobile() {
        if (this.platform.is('mobile')) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    getGlobalLimits() {
         this.responsibleGamingProvider.getGlobalLimits().subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    this.globalLimits = response.payload.filter((limit) => {
                        return limit.limitType == "TIME";
                    });

                    this.globalLimits.forEach((limit) => {
                        if (limit.limitTermType == "DAILY") {
                            this.globalDailyLimit = limit;
                            this.time_limit.setValidators([Validators.pattern('^[0-9]*'), Validators.max(this.globalDailyLimit.currentLimit)]);
                        }
                    });
                }
            },
            (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        );
    }

    getTotalLoginTime() {
        this.responsibleGamingProvider.getTotalLoginTime(this.configService.getClientApp()).subscribe(
            (response: any) => {
                if (response && !!response.result) {

                    this.totalLoginTime = 0;
                    if (0 < parseInt(response.payload.time)) {
                        this.totalLoginTime = this.secondsToTime(parseInt(response.payload.time));
                    }
                    this.getTimeLimits();
                }
            },
            (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        );
    }

    secondsToTime(seconds: any) {
        let h: string | number = Math.floor(seconds / 3600);
        let m: string | number = Math.floor((seconds - (h * 3600)) / 60);
        let s: string | number = seconds - (h * 3600) - (m * 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        return `${h}:${m}:${s}`;
    }

    getTimeLimits() {
        var tempLimits: any[] = [];

        this.responsibleGamingProvider.getTimeLimit().subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    tempLimits = response.payload;

                    for (let index in tempLimits) {
                        if (tempLimits[index].limitSource != "GLOBAL") {
                            tempLimits[index].cumulativeLimitValue = this.totalLoginTime;
                            this.timeLimits.push(tempLimits[index]);
                        }
                    }

                    this.updateTimeLimits(this.timeLimits);
                }
            },
            (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        );
    }

    updateTimeLimits(timeLimits: any[]) {
        this.time_limit.setValue("");
        this.time_limit.markAsPristine();

        this.timeNewLimitError.nativeElement.style.display = "none";

        for (let i in timeLimits) {
            if (timeLimits[i] != null) {
                if (timeLimits[i].currentLimitTermType == "DAILY") {
                    if (timeLimits[i].currentLimit != null || timeLimits[i].currentLimit != "") {
                        this.timeCurrentLimit.nativeElement.innerHTML = timeLimits[i].currentLimit;
                        this.timeDelete.nativeElement.style.display = "flex";
                    }
                    else {
                        this.timeCurrentLimit.nativeElement.innerHTML = "(No limit set)";
                        this.timeDelete.nativeElement.style.display = "none";
                    }

                    if (timeLimits[i].startPeriod != null && timeLimits[i].endPeriod != null) {
                        if (timeLimits[i].cumulativeLimitValue == null) {
                            timeLimits[i].cumulativeLimitValue = "00:00:00";
                        }

                        this.timeRolloverPeriod.nativeElement.style.display = "flex";
                        this.timeRolloverPeriodContent.nativeElement.innerHTML = this.dateFormatPipe.transform(timeLimits[i].startPeriod) + " TO  <br>"
                        + this.dateFormatPipe.transform(timeLimits[i].endPeriod);

                        this.timeAmountUsed.nativeElement.style.display = "flex";
                        this.timeAmountUsedContent.nativeElement.innerHTML = timeLimits[i].cumulativeLimitValue;
                    }

                    if (timeLimits[i].newLimit && timeLimits[i].endPeriod) {
                        this.timeDelete.nativeElement.style.display = "none";
                        this.timeNewLimit.nativeElement.style.display = "flex";
                        this.timePendingLimitContent.nativeElement.innerHTML = timeLimits[i].newLimit;
                        this.timePendingLimit.nativeElement.style.display = "flex";
                        this.timeNewLimitEffective.nativeElement.style.display = "flex";
                        this.timeNewLimitEffectiveContent.nativeElement.innerHTML = this.dateFormatPipe.transform(timeLimits[i].endPeriod);
                        this.timeRemoved.nativeElement.style.display = "none";
                    }
                    else if (!timeLimits[i].newLimit && timeLimits[i].deleteFlag == "1") {
                        this.timeDelete.nativeElement.style.display = "none";
                        this.timeNewLimit.nativeElement.style.display = "flex";
                        this.timePendingLimit.nativeElement.style.display = "none";
                        this.timeNewLimitEffective.nativeElement.style.display = "none";
                        this.timeRemoved.nativeElement.style.display = "flex";
                        this.timeRemovedContent.nativeElement.innerHTML = this.dateFormatPipe.transform(timeLimits[i].endPeriod);
                    }
                    else {
                        //This is the case based on above 2 condition that
                        //user has lowered the limit against what currently limit is set
                        //so, it will update the UI to remove the pending limit information
                        this.timePendingLimit.nativeElement.style.display = "none";
                        this.timeNewLimitEffective.nativeElement.style.display = "none";
                    }
                }
            }
        }
    }

    deleteLimit(event: Event, term: string) {
        event.preventDefault();

        this.successMessageProvider.clearMessage();
        this.error = null;

        var requestObj: any = {};
        requestObj.termType = term.toUpperCase();

        this.responsibleGamingProvider.deleteTimeLimit(requestObj).subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    this.getTotalLoginTime();
                }
            },
            (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        );
    }

    setLimits( ) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        this.responsibleGamingProvider.setTimeLimit(this.timeLimitForm.value).subscribe(
            (response: any) => {
                if (response && !!response.result ) {
                    this.getTotalLoginTime();

                    this.successMessageProvider.setMessage('Your time limit was set.');
                    this.content.scrollToTop(10);;
                }
            },
            (error) => {

                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TERM_TYPE':
                        error.setErrorMessage('Limit cannot be 0!');
                        break;
                    default:
                        error.setErrorMessage('');
                        break;
                }
                this.error = error;
                this.content.scrollToTop();
            }
        );
    }

    dailyLimitChanged() {
        if (this.globalDailyLimit != null) {
            if (parseInt(this.time_limit.value) > parseInt(this.globalDailyLimit.currentLimit)) {
                this.timeNewLimitError.nativeElement.style.display = "flex";
            }
            else {
                this.timeNewLimitError.nativeElement.style.display = "none";
            }
        }
    }

    atLeastOneFieldValidator(group: FormGroup): {[key: string]: any} {
        let isAtLeastOne = false;
        if (group && group.controls) {
            for (const control in group.controls) {
                if (group.controls.hasOwnProperty(control) && group.controls[control].valid && group.controls[control].value) {
                    isAtLeastOne = true;
                    break;
                }
            }
        }
        return isAtLeastOne ? null : { 'required': true };
    }

    onClose = () =>{
        this.limitsService.onCloseCommon(this.previousPage == "SignupResult");
    }
}
